export default function (ctx, inject) {
    // Options
    const nuxtConfigOptions = {"searchCategories":["products"]}

    inject('moduleOptions', nuxtConfigOptions)
}
